import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UniversitiesStore } from '../data-access/+state/universities.store';
import { HEADER_DATA } from '../static/universities.properties';

@Injectable({
	providedIn: 'root',
})
export class UniversitiesService {
	readonly store = inject(UniversitiesStore);

	private _router = inject(Router);

	headerData = signal({ ...HEADER_DATA });

	determineClearingRoute() {
		const isClearing = this._router.url.split('/').filter(Boolean)[1];
		return isClearing ? isClearing.startsWith('clearing') : false;
	}
}
